export const environment = {
    production: true,
    // apiBaseUrl: "https://fixz.co.uk/api",
    // domain: 'https://fixz.co.uk'
    apiBaseUrl: "https://fixz.app/api",
    domain: 'https://fixz.app',
    appVersion: '1.0.0',
};
